import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { ArrowLeft, Sparkles, Send, CheckCircle2 } from "lucide-react";

export default function ContactSales() {
  const [form, setForm] = useState({ name: "", email: "", company: "", team_size: "", message: "" });
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try { await api.post("/contact-sales", form); setDone(true); }
    catch (e) { setError(formatApiError(e.response?.data?.detail) || e.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="max-w-2xl mx-auto px-6 lg:px-10 py-16">
      <Link to="/billing" className="inline-flex items-center gap-1 text-sm font-semibold hover:text-[var(--brand-primary)]">
        <ArrowLeft className="w-4 h-4" /> Back to plans
      </Link>
      <div className="mt-8">
        <div className="label-eyebrow flex items-center gap-1.5"><Sparkles className="w-3 h-3 text-[var(--brand-primary)]" /> Enterprise</div>
        <h1 className="font-display font-black text-5xl tracking-tight mt-3">Let's talk.</h1>
        <p className="text-[#5C5C5C] mt-3">Enterprise is custom — bespoke branding, your own domain, SLA-backed support, and unlimited everything. Tell us about your team and we'll be in touch within one business day.</p>
      </div>
      {done ? (
        <div className="mt-10 border border-[#0F0F0F] p-8 text-center" data-testid="sales-done">
          <CheckCircle2 className="w-12 h-12 mx-auto text-[var(--brand-primary)]" />
          <h2 className="font-display font-black text-2xl mt-4">Got it.</h2>
          <p className="text-sm text-[#5C5C5C] mt-2">A confirmation has been sent to {form.email}. We'll reach out shortly.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="mt-10 space-y-5">
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="label-eyebrow block mb-1.5">Your name</label>
              <input data-testid="sales-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full border border-[#0F0F0F] px-3 py-2 bg-transparent" />
            </div>
            <div>
              <label className="label-eyebrow block mb-1.5">Work email</label>
              <input data-testid="sales-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full border border-[#0F0F0F] px-3 py-2 bg-transparent" />
            </div>
            <div>
              <label className="label-eyebrow block mb-1.5">Company</label>
              <input data-testid="sales-company" value={form.company} onChange={(e) => setForm({ ...form, company: e.target.value })} className="w-full border border-[#0F0F0F] px-3 py-2 bg-transparent" />
            </div>
            <div>
              <label className="label-eyebrow block mb-1.5">Team size</label>
              <select data-testid="sales-team-size" value={form.team_size} onChange={(e) => setForm({ ...form, team_size: e.target.value })} className="w-full border border-[#0F0F0F] px-3 py-2 bg-transparent">
                <option value="">choose…</option>
                <option value="10-50">10–50</option>
                <option value="50-200">50–200</option>
                <option value="200-1000">200–1000</option>
                <option value="1000+">1000+</option>
              </select>
            </div>
          </div>
          <div>
            <label className="label-eyebrow block mb-1.5">Anything we should know? (optional)</label>
            <textarea data-testid="sales-message" rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="w-full border border-[#0F0F0F] px-3 py-2 bg-transparent" placeholder="Current ATS, must-have integrations, hiring volume…" />
          </div>
          {error && <div data-testid="sales-error" className="text-sm text-[var(--brand-primary)]">{error}</div>}
          <button disabled={loading} data-testid="sales-submit" type="submit" className="btn-terra"><Send className="w-4 h-4" /> {loading ? "Sending…" : "Contact sales"}</button>
        </form>
      )}
    </div>
  );
}
